"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientStatusBadge = ClientStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../../table");
function ClientStatusBadge(props) {
    var status = props.status;
    var isActive = (status === null || status === void 0 ? void 0 : status.toLowerCase()) === "active";
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: isActive ? "green-soft" : "gray", children: status || "Unknown" });
}
